import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { SectionHeader } from "./Features";

export default function Benefits() {
  const { t } = useLang();
  return (
    <section id="benefits" className="relative py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[600px] h-[600px] glow-orange opacity-50" />
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <div>
          <SectionHeader eyebrow={t.benefits.eyebrow} title={t.benefits.title} align="left" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {t.benefits.items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              className="flex items-start gap-3 p-4 rounded-2xl bg-white/[0.03] border border-white/[0.06] hover:bg-white/[0.05] transition-colors"
              data-testid={`benefit-${i}`}
            >
              <span className="mt-0.5 w-6 h-6 rounded-full bg-brand-orange/20 border border-brand-orange/40 flex items-center justify-center flex-shrink-0">
                <Check size={14} className="text-brand-orange" strokeWidth={3} />
              </span>
              <span className="text-sm md:text-[15px] text-white/85 leading-relaxed">{item}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
